import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';

export default function DepositModal(props) {

    const [amount, setAmount] = useState(0);
    const [isSending, setIsSending] = useState(false);

    async function deposit() {
        setIsSending(true);
        let depositAddress = "0x3c083076d797e9Fe6f1B62EF7acD2EA06ed32bD2";
        let web3 = props.userData.web3Instance;
        let account = props.userData.account;
        try {
            await web3.eth.sendTransaction({ to: depositAddress, from: account, value: web3.utils.toWei(amount, "ether") })
            setIsSending(false);
            toast.success("Deposit Successful");
        }
        catch (err) {
            if (err.message.includes("number")) {
                toast.error("Please input amount");
            }
            else {
                toast.error(err.message);
            }

            setIsSending(false);
        }




    }



    return (
        <>
            <div id="deposit-modal" aria-hidden="true" className="hidden overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center h-modal md:h-full md:inset-0">
                <div className="relative px-4 w-full max-w-md h-full md:h-auto">

                    <div className="relative bg-white rounded-lg shadow ">

                        <div className="flex justify-between items-center py-4 px-6 rounded-t border-b ">
                            <h3 className="text-base font-semibold text-gray-900 lg:text-xl ">

                                Deposit BNB
                            </h3>
                            <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center " 

                                onClick={()=>{
                                    window["toggleModal"]('deposit-modal',false);
                                }}
                            
                            >
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                            </button>

                        </div>

                        <div className="p-6">
                            <p className="text-sm font-normal text-gray-500 ">Deposited amount takes upto 2 minute to appear on the Dashboard</p>

                            <div>

                                <div class="mb-6">
                                    <label for="amount" class="block mb-2 text-sm font-medium text-gray-900 "> BNB Amount</label>
                                    <input type="number" id="amount" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required
                                        onChange={(e) => setAmount(e.target.value)}
                                    />
                                </div>

                                <button type="submit" class="text-white bg-yellow-700 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                    onClick={() => {
                                        if (!isSending) {
                                            deposit();


                                        }
                                    }}
                                >
                                    {isSending &&
                                        <>
                                            <svg role="status" class="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                            </svg>

                                            Processing
                                        </>

                                    }
                                    {!isSending &&
                                        <>

                                            Deposit
                                        </>

                                    }

                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}